var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2363 18.4388L20.1671 18.0884C19.8062 18.046 19.4404 18.086 19.0972 18.2052C18.754 18.3245 18.4422 18.5201 18.1854 18.7771L15.9621 21.0005C12.5319 19.2559 9.74374 16.4678 7.99917 13.0376L10.2346 10.8021C10.7542 10.2826 11.0079 9.55755 10.9233 8.82047L10.5729 5.77547C10.5044 5.18602 10.2215 4.64234 9.77812 4.24795C9.33472 3.85357 8.76176 3.63602 8.16834 3.63672H6.07792C4.7125 3.63672 3.57667 4.77255 3.66125 6.13797C4.30167 16.4571 12.5546 24.698 22.8617 25.3384C24.2271 25.423 25.3629 24.2871 25.3629 22.9217V20.8313C25.375 19.6109 24.4567 18.5838 23.2363 18.4388Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallicon);
export default __webpack_public_path__ + "static/media/callicon.9bc950a25f3c36d79583ffd37f527c6d.svg";
export { ForwardRef as ReactComponent };